import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(
  ({ typography }) => ({
    verticalLine: {
      display: 'block',
      height: '100%',
      minHeight: '48px',
      border: '1px solid #F7F7F7',
      margin: '0 8px',
    },
    currencyButton: {
      border: 'none',
      '&.MuiInput-underline::after, &.MuiInput-underline::before': {
        display: 'none',
      },
      '& #currency-select': {
        height: '20px',
        minWidth: '36px',
        borderRadius: '10px',
        background: '#F7F7F7',
        color: '#212529',
        padding: '16px 20px 10px 16px',
      },
      '& .MuiSelect-icon': {
        top: 'calc(50% - 11px)',
        right: '4px',
      },
    },
    tableWrapper: {
      borderRadius: '10px',
      '&.fullWidth': {
        gridColumn: 'span 3 / auto',
        backgroundColor: '#ffffff',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
        padding: '20px',
      },
      '& .MuiTableHead-root': {
        borderTop: '#EAEAEA solid 1px',
      },
      '& .MuiTableCell-root': {
        'padding-right': '30px !important',
      },
      '@media (max-width: 1200px)': {
        '& .MuiTableCell-root': {
          'padding-right': '20px !important',
        },
        '& th.MuiTableHead-root, & td.MuiTableCell-root': {
          fontSize: '12px',
          '& span': {
            fontSize: '11px',
          },
        },
      },
      '& td': {
        padding: '10px 0px !important',
      },
      '& th': {
        paddingTop: '20px !important',
      },
    },
    emptyTable: {
      position: 'relative',
      margin: '80px',
      top: 'auto',
      left: 'auto',
      transform: 'none',
    },
    tableLink: {
      fontSize: 14,
      fontWeight: typography.fontWeightSemiBold,
    },
    rateLink: {
      fontSize: 14,
      fontWeight: typography.fontWeightSemiBold,
      color: 'rgb(9, 131, 117)',
    },
    amount: {
      fontWeight: 600,
    },
    status: {
      minWidth: '130px',
      textAlign: 'center',
    },

  }),
  { name: 'ExternalTradesMtmTable' },
);

export default useStyles;
